import { gql } from '@apollo/client';

export const fetchAnalyticsMetrics = gql`
  query getAnalyticsMetrics($messageMedium: MessageMediumDefinition, $page: Page) {
    analyticsMetrics(messageMedium: $messageMedium, page: $page) {
      metricName
      metricNiceName
      category
      valueType
      mediums
    }
  }
`;

export const fetchHighLevelMetrics = gql`
  query getHighLevelMetrics($messageMedium: MessageMediumDefinition, $page: Page) {
    highLevelMetrics(messageMedium: $messageMedium, page: $page) {
      metricName
      metricNiceName
      category
      mediums
      valueType
      metrics {
        metricName
      }
    }
  }
`;
